<div mat-dialog-title class="w-100">
    <div
        class="title d-flex align-items-center justify-content-space-between pop-up-header head"
    >
        <h4 class="mb-0 pop-up-text">
          
        </h4>
        <button
            class="close-button"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
</div>
<div class="body">
    <div class="container">
        <div class="header">
            <h1>Student Applicant Consent for Data Sharing with Partner Organisations</h1>
        </div>

        <div class="privacy-notice">
            <p><strong>Important:</strong> Before completing this form you should ensure that you have been provided with, and read, the University's Student Applicant Privacy Notice.</p>
            <p>The Privacy Notice and other information relating to the University's use of your data can be viewed on our website here: 
                <a href="https://www.birmingham.ac.uk/privacy/admissions.aspx" target="_blank">https://www.birmingham.ac.uk/privacy/admissions.aspx</a>
            </p>
        </div>

        <div class="section">
            <div class="section-title">Applicant Information</div>
            <div class="form-group">
                <label for="name">Name:</label>
                <span>{{fullName}}</span>
            </div>
            <div class="form-group">
                <label for="programme">Date of Birth</label>
                <span>{{dateOfBirth}}</span>
            </div>
            <div class="form-group">
                <label for="programme">Programme applied for:</label>
                <span>{{courseName}}</span>
            </div>
            
        </div>

        <div class="section">
            <div class="section-title">Declaration</div>
            
            <div class="checkbox-group">
                <label for="declaration">
                    I confirm that I have been provided with and have read the University of Birmingham's Privacy Notice for Student Applicants and I understand how my data will be used by the University.
                </label>
            </div>
            
            <div class="form-group">
                <label>Signed</label>
            </div>
        </div>

        <div class="section">
            <div class="section-title">Consent for data to be shared with a partner organisation</div>
            
            <div class="checkbox-group">
                <label for="consent">
                    I consent for my personal data and information about my application for the above programme to be shared with:
                </label>
            </div>
            
            <div class="form-group">
                <input type="text" id="organisation" name="organisation" placeholder="Name of organisation" readonly>
            </div>
            <div class="form-group">
                <label>Signed</label>
            </div>
            <div class="button-container">
                <button class="submit-button" (click)="sendForSignature()">Send for signature</button>
            </div>
        </div>
    </div>
</div>

